import React from "react";

const MyContext = React.createContext(null as any);

export default MyContext